import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import { openRecords } from "utils/RecordUtils";
import { Dropdown } from "rsuite";
import useUser from "api/api-hooks/auth/useUser";
import useCloudPermissions from "../../hooks/useCloudPermissions";
import useWorkspacePermissions from "../../hooks/useWorkspacePermissions";
import { useAtomValue } from "jotai";
import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";
import { tenantIDAtom } from "atoms/GlobalAtoms";

const TableActionsMenu = ({
  moduleAPIName,
  selectedRecords,
  setSelectedRecords,
  toggleUpdate,
  toggleUpdateTags,
  isSelection,
  toggleMerge,
  onDuplicate,
  setExportDrawer,
  deleteSelectedRecords,
  availableOptions = [
    "ExportSelectedRecords",
    "BulkUpdateRecords",
    "BulkTags",
    "DeleteSelectedRecords",
    "OpenSelectedRecords",
    "DuplicateRecords",
    "MergeRecords",
  ],
  parentRecord,
  publicForm = false,
}) => {
  const { cPermissions } = useCloudPermissions();
  const { wPermissions } = useWorkspacePermissions();
  const tenantID = useAtomValue(tenantIDAtom);
  const { user } = useUser();

  const openSelectedRecords = () => {
    openRecords(tenantID, moduleAPIName, selectedRecords);
  };

  const handleExportSelectedRecords = () => {
    setExportDrawer(true);
  };

  const permissionToBulkActions = () => {
    let lockedRecordNoPermission = false;
    if (cPermissions.cloud_unlock_records) {
      return true;
    }

    if (parentRecord) {
      if (
        parentRecord.CreatedBy.id !== user.id &&
        parentRecord._LockedBy !== user.id
      ) {
        lockedRecordNoPermission = true;
      }
    } else {
      for (let i = 0; i < selectedRecords.length; i++) {
        const record = selectedRecords[i];
        if (record._LockedBy) {
          if (record.CreatedBy.id !== user.id && record._LockedBy !== user.id) {
            lockedRecordNoPermission = true;
          }
        }
      }
    }

    return lockedRecordNoPermission ? false : true;
  };

  const canUseBulkOperations = permissionToBulkActions();

  const options = [
    {
      key: "ExportSelectedRecords",
      name: "Export Selected Records",
      onClick: () => handleExportSelectedRecords(),
      icon: "mdi mdi-file-export",
      disabled: false,
      divider: true,
    },
    {
      key: "BulkUpdateRecords",
      name: "Bulk Update Records",
      onClick: toggleUpdate,
      icon: "mdi mdi-pencil",
      disabled:
        !isSelection ||
        !cPermissions.cloud_modify_record ||
        !canUseBulkOperations,
      divider: false,
    },
    {
      key: "BulkTags",
      name: "Bulk Apply/Remove Tags",
      onClick: toggleUpdateTags,
      icon: "mdi mdi-tag-multiple",
      disabled:
        !isSelection ||
        !cPermissions.cloud_modify_record ||
        !canUseBulkOperations,
      divider: false,
    },
    {
      key: "DeleteSelectedRecords",
      name: "Delete Selected Records",
      onClick: deleteSelectedRecords,
      icon: "mdi mdi-delete",
      disabled:
        !isSelection ||
        (!cPermissions.cloud_delete_record && !publicForm) ||
        !canUseBulkOperations,
      divider: false,
    },
    {
      key: "OpenSelectedRecords",
      name: "Open Selected Records",
      onClick: openSelectedRecords,
      icon: "mdi mdi-open-in-new",
      disabled: !isSelection,
      divider: false,
    },
    {
      key: "DuplicateRecords",
      name: "Duplicate Record",
      icon: "mdi mdi-content-copy",
      onClick: onDuplicate,
      disabled:
        !onDuplicate || selectedRecords?.length !== 1 || !canUseBulkOperations,
      divider: false,
    },
    {
      key: "MergeRecords",
      name: "Merge Records",
      icon: "mdi mdi-merge",
      onClick: toggleMerge,
      disabled:
        !toggleMerge ||
        selectedRecords?.length !== 2 ||
        !canUseBulkOperations ||
        publicForm,
      divider: false,
    },
  ];

  const optionsSelected = options.filter((option) =>
    availableOptions.includes(option.key)
  );

  return (
    <Dropdown.Menu>
      <h5 className="px-2 pt-2 text-dark">Actions</h5>
      {optionsSelected.map((option) => (
        <div key={option.key}>
          {option.divider && <DropdownMenuDivider></DropdownMenuDivider>}
          <DropdownOptionWithIcon
            name={option.name}
            onClick={option.onClick}
            icon={option.icon}
            disabled={option.disabled}
          ></DropdownOptionWithIcon>
        </div>
      ))}
    </Dropdown.Menu>
  );
};

export default TableActionsMenu;
